import {z} from 'zod';

export const RequestDetailSegmentFormTypeSchema = z.object({
  name: z.string().nullish(),
  description: z.string().nullish(),
  neededAt: z.date().nullish(),
});

export type RequestDetailSegmentFormType = z.infer<typeof RequestDetailSegmentFormTypeSchema>;
